export const FLOW_BY_ID = 'flow-by-id';
export const FLOW_VALIDATION = 'flow-validation';
export const OBJECT_TYPES = 'object-types';